// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1072":"274052f4","1080":"ca90bb08","7994":"274052f4"}[chunkId] + ".chunk.css";
};